import React, { useEffect, useState } from "react";
import { getLotteryData } from "../../services/HomeServices";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import img from "../../assets/images/dream-prize.jpeg";
import _ from "lodash";
import "./HomePage.css";
import { addLottery } from "../../services/AuthServices";
import { getUserId, isLogin } from "../../lib/constant";
import DrawTCPopup from "../../containers/DrawTCPopup";

const DrawModule = () => {
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [selectedDraw, setselectedDraw] = useState(undefined);
  const [submitLoading, setsubmitLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setisLoading(true);
    try {
      const response = await getLotteryData(1, 12, getUserId());
      setdata(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching draws:", error);
      setdata([]);
    } finally {
      setisLoading(false);
    }
  };

  const handleBuyClick = (draw) => {
    if (!isLogin()) {
      toast("Please login to participate in draw", { type: "warning" });
      navigate("/login");
      return;
    }
    setselectedDraw(draw);
    setModalIsOpen(true);
  };

  const buyClicked = async () => {
    setsubmitLoading(true);
    try {
      let formdata = new FormData();
      formdata.append("lotteryId", selectedDraw?.id);

      await addLottery(formdata);

      setselectedDraw(undefined);
      setModalIsOpen(false);
      toast("Successfully registered for the draw!", { type: "success" });
      navigate("/account-detail", { state: { draw: true } });
    } catch (error) {
      const message = error?.response?.data?.message || "Something went wrong";
      toast(message, { type: "error" });
    } finally {
      setsubmitLoading(false);
      setselectedDraw(undefined);
      setModalIsOpen(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const options = { day: "2-digit", month: "short", year: "numeric" };
      return new Date(dateString).toLocaleDateString("en-IN", options);
    } catch {
      return dateString;
    }
  };

  return (
    <section className="draw-section" id="draws">
      <div className="draw-container">
        <div className="section-header">
          <div className="section-title">
            <div className="section-icon">
              <i className="far fa-gift"></i>
            </div>
            <h2>Lucky Draws</h2>
          </div>
          <Link to="/draws" className="view-all-btn">
            View All <i className="fas fa-arrow-right"></i>
          </Link>
        </div>
        <p className="section-subtitle">Participate in exciting draws and win amazing prizes!</p>

        <div className="draw-grid">
          {isLoading ? (
            <div className="loading-container">
              <div className="modern-spinner"></div>
            </div>
          ) : !_.isEmpty(data) ? (
            data.slice(0, 12).map((draw, i) => (
              <div className="draw-card" key={draw?.id || i}>
                <div className="draw-image-wrapper">
                  <img
                    src={draw?.image || img}
                    alt={draw?.name || "Draw"}
                    loading="lazy"
                    onError={(e) => { e.target.src = img; }}
                  />
                  <span className="draw-badge">
                    <i className="far fa-star"></i> Featured
                  </span>
                </div>

                <div className="draw-content">
                  <h3 className="draw-name">{draw?.name || "Draw"}</h3>
                  <p className="draw-description">
                    {draw?.lottery_detail || "No description available"}
                  </p>

                  <div className="draw-details">
                    <div className="draw-detail-row">
                      <span className="draw-detail-label">
                        <i className="far fa-calendar-alt"></i> Start Date
                      </span>
                      <span className="draw-detail-value">
                        {formatDate(draw?.start_date)}
                      </span>
                    </div>
                    <div className="draw-detail-row">
                      <span className="draw-detail-label">
                        <i className="far fa-calendar-check"></i> End Date
                      </span>
                      <span className="draw-detail-value">
                        {formatDate(draw?.expire_date)}
                      </span>
                    </div>
                    <div className="draw-detail-row">
                      <span className="draw-detail-label">
                        <i className="far fa-users"></i> Participants
                      </span>
                      <span className="draw-detail-value highlight">
                        {draw?.number_of_participate || 0}
                      </span>
                    </div>
                  </div>

                  <div className="draw-price-section">
                    <div className="draw-price">
                      <span className="draw-price-label">Entry Fee</span>
                      <span className="draw-price-value">
                        <i className="fas fa-coins"></i> {draw?.buy_in || 0} Coins
                      </span>
                    </div>
                    <button
                      className="draw-buy-btn"
                      disabled={submitLoading}
                      onClick={() => handleBuyClick(draw)}
                    >
                      <i className="far fa-ticket-alt"></i> Enter Draw
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon">
                <i className="far fa-gift"></i>
              </div>
              <h4>No Draws Available</h4>
              <p>Check back later for exciting draw opportunities!</p>
            </div>
          )}
        </div>

        <DrawTCPopup
          isOpen={modalIsOpen}
          onClose={() => {
            setModalIsOpen(false);
            setselectedDraw(undefined);
          }}
          onAccept={buyClicked}
          drawName={selectedDraw?.name || ""}
          buyInAmount={selectedDraw?.buy_in || 0}
          isLoading={submitLoading}
        />
      </div>
    </section>
  );
};

export default DrawModule;
